module.exports = __webpack_public_path__ + "static/media/mobile-screen-button-solid.0d7ebbe7.svg";